module.exports = __webpack_public_path__ + "img/restaurant.baf4a3a4.png";